module.exports = __webpack_public_path__ + "static/media/hangman0.65741784.png";